export default {
  title: 'Hvad synes du om {{name}}?',
  description: 'Din feedback er anonym og hjælper os med at blive bedre.',
  upload_google_review: {
    title: 'Anmeld os og bliv belønnet',
  },
};
